var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"4"}},[_c('v-card',{staticClass:"pa-4"},[_c('h3',[_vm._v("Duração")]),(_vm.item.asus.booking_policy.period.min)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.period.min_${_vm.item.asus.periodicity.type}`,
              _vm.item.asus.booking_policy.period.min,
              { min: _vm.item.asus.booking_policy.period.min }
            )
          )}}):_vm._e(),(_vm.item.asus.booking_policy.period.max)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.period.max_${_vm.item.asus.periodicity.type}`,
              _vm.item.asus.booking_policy.period.max,
              { max: _vm.item.asus.booking_policy.period.max }
            )
          )}}):_vm._e()])],1),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"4"}},[_c('v-card',{staticClass:"pa-4"},[_c('h3',[_vm._v("Periodicidade")]),(_vm.item.asus.periodicity)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.period.unique_${_vm.item.asus.periodicity.type}`,
              _vm.item.asus.periodicity.value,
              { unique: _vm.item.asus.periodicity.value }
            )
          )}}):_vm._e()])],1),(_vm.item.asus.formula.base.includes('I'))?_c('v-col',{attrs:{"cols":"12","sm":"12","md":"4"}},[_c('v-card',{staticClass:"pa-4"},[_c('h3',[_vm._v("Inserções")]),(_vm.insertionsOptions)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.insertionsOptions)}}):_vm._e(),(!_vm.insertionsOptions)?[(_vm.item.asus.booking_policy.insertions.min)?_c('div',{domProps:{"innerHTML":_vm._s(
              _vm.$tc(
                `bookingPolicy.insertions.min`,
                _vm.item.asus.booking_policy.insertions.min,
                {
                  min: _vm.item.asus.booking_policy.insertions.min,
                  label: _vm.item.asus.custom_messages.msg_insertions,
                }
              )
            )}}):_vm._e(),(_vm.item.asus.booking_policy.insertions.max)?_c('div',{domProps:{"innerHTML":_vm._s(
              _vm.$tc(
                `bookingPolicy.insertions.max`,
                _vm.item.asus.booking_policy.insertions.max,
                {
                  max: _vm.item.asus.booking_policy.insertions.max,
                  label: _vm.item.asus.custom_messages.msg_insertions,
                }
              )
            )}}):_vm._e()]:_vm._e()],2)],1):_vm._e(),(_vm.item.asus.formula.base.includes('Q'))?_c('v-col',{attrs:{"cols":"12","sm":"12","md":"4"}},[_c('v-card',{staticClass:"pa-4"},[_c('h3',[_vm._v("Quantidade")]),(_vm.item.asus.booking_policy.quantity.options)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.quantity.max`,
              _vm.item.asus.booking_policy.quantity.max,
              {
                min: _vm.item.asus.booking_policy.quantity.max,
                label: _vm.item.asus.custom_messages.msg_quantity,
              }
            )
          )}}):[(_vm.item.asus.booking_policy.quantity.min)?_c('div',{domProps:{"innerHTML":_vm._s(
              _vm.$tc(
                `bookingPolicy.quantity.min`,
                _vm.item.asus.booking_policy.quantity.min,
                {
                  min: _vm.item.asus.booking_policy.quantity.min,
                  label: _vm.item.asus.custom_messages.msg_quantity,
                }
              )
            )}}):_vm._e(),(_vm.item.asus.booking_policy.quantity.max)?_c('div',{domProps:{"innerHTML":_vm._s(
              _vm.$tc(
                `bookingPolicy.quantity.max`,
                _vm.item.asus.booking_policy.quantity.max,
                {
                  max: _vm.item.asus.booking_policy.quantity.max,
                  label: _vm.item.asus.custom_messages.msg_quantity,
                }
              )
            )}}):_vm._e()]],2)],1):_vm._e()],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6"}},[_c('v-card',{staticClass:"pa-4"},[_c('h3',[_vm._v("Prazos")]),(_vm.item.asus.booking_policy.reservation_period.min)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.reservation.min`,
              _vm.item.asus.booking_policy.reservation_period.min,
              { count: _vm.item.asus.booking_policy.reservation_period.min }
            )
          )}}):_vm._e(),(_vm.item.asus.booking_policy.reservation_period.max)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.reservation.max`,
              _vm.item.asus.booking_policy.reservation_period.max,
              { count: _vm.item.asus.booking_policy.reservation_period.max }
            )
          )}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(`bookingPolicy.reservation.payment`))}})])],1),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6"}},[_c('v-card',{staticClass:"pa-4"},[_c('h3',[_vm._v("Políticas Comerciais")]),_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$t(`bookingPolicy.commercial.investment.min`, _vm.minPrice, {
              value: _vm.minPrice,
            })
          )}}),_vm._l((_vm.ssus),function(ssu,i){return _c('div',{key:i,domProps:{"innerHTML":_vm._s(_vm.$t(`bookingPolicy.commercial.required_${ssu}`))}})}),(_vm.item.asus.booking_policy.reservation_period.min)?_c('div',{domProps:{"innerHTML":_vm._s(
            _vm.$tc(
              `bookingPolicy.commercial.cancel.min`,
              _vm.item.asus.booking_policy.reservation_period.min,
              { count: _vm.item.asus.booking_policy.reservation_period.min }
            )
          )}}):_vm._e()],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }